(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.slInit) return;
      root.dataset.slInit = '1';
      const slides = [...root.querySelectorAll('.sl-ann__slide')];
      if (slides.length < 2 || root.dataset.autoplay !== 'true') return;
      const ms = (parseInt(root.dataset.speed, 10) || 5) * 1000;
      let i = 0;
      let paused = false;
      root.addEventListener('mouseenter', () => (paused = true));
      root.addEventListener('mouseleave', () => (paused = false));
      setInterval(() => {
        if (paused) return;
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, ms);
    };
    const all = () => document.querySelectorAll('[data-sl-ann]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
    else all();
    document.addEventListener('shopify:section:load', all);
    document.addEventListener('shopify:block:select', (e) => {
      const slide = e.target.closest && e.target.closest('.sl-ann__slide');
      if (!slide) return;
      slide.parentElement.querySelectorAll('.sl-ann__slide').forEach((s) => s.classList.toggle('is-active', s === slide));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-nico"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(min-width: 750px)');
    function sync() {
      document.querySelectorAll('.section-footer-nico .fn__details').forEach(function (d) {
        if (mq.matches) {
          d.setAttribute('open', '');
          d.dataset.fnForced = '1';
        } else if (d.dataset.fnForced) {
          d.removeAttribute('open');
          delete d.dataset.fnForced;
        }
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sync);
    } else {
      sync();
    }
    if (mq.addEventListener) {
      mq.addEventListener('change', sync);
    } else if (mq.addListener) {
      mq.addListener(sync);
    }
    document.addEventListener('shopify:section:load', sync);
    document.addEventListener('click', function (e) {
      if (!mq.matches) return;
      var summary = e.target.closest('.section-footer-nico .fn__summary');
      if (summary) e.preventDefault();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-selora"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      root.querySelectorAll('.sfo--acordeon .sfo__toggle').forEach(function (btn) {
        if (btn.dataset.sfoReady) return;
        btn.dataset.sfoReady = '1';
        btn.addEventListener('click', function () {
          var col = btn.closest('.sfo__col--menu');
          var open = !col.classList.contains('is-open');
          col.classList.toggle('is-open', open);
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};
      this.setHeaderHeight();
      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if ([...this.predictiveSearches].some((p) => p.isOpen)) return;
      if (this.querySelector('.sl-dr.is-open')) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.querySelectorAll('details[data-sl-mega][open]').forEach((d) => d.removeAttribute('open'));
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((m) => m.close(false));
    }
  }
  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  /* Mega menú: abre al pasar el mouse (y con clic / teclado) */
  (() => {
    if (window.__slMegaLoaded) return;
    window.__slMegaLoaded = true;
    const hover = window.matchMedia('(hover: hover)');

    const place = (details) => {
      const wrap = details.closest('.sl-hd');
      const summary = details.querySelector('summary');
      if (!wrap || !summary) return;
      const top = summary.getBoundingClientRect().bottom - wrap.getBoundingClientRect().top;
      details.style.setProperty('--sl-mega-top', `${Math.round(top)}px`);
    };
    const open = (d) => {
      document.querySelectorAll('details[data-sl-mega][open]').forEach((o) => o !== d && o.removeAttribute('open'));
      place(d);
      d.setAttribute('open', '');
    };
    const close = (d) => d.removeAttribute('open');

    document.addEventListener('mouseover', (e) => {
      if (!hover.matches) return;
      const item = e.target.closest('.sl-hd__item');
      const d = item && item.querySelector('details[data-sl-mega]');
      if (d && !d.open) open(d);
    });
    document.addEventListener('mouseout', (e) => {
      if (!hover.matches) return;
      const item = e.target.closest('.sl-hd__item');
      if (!item || (e.relatedTarget && item.contains(e.relatedTarget))) return;
      const d = item.querySelector('details[data-sl-mega]');
      if (d && d.open) close(d);
    });
    document.addEventListener('click', (e) => {
      const summary = e.target.closest('details[data-sl-mega] > summary');
      if (summary) {
        e.preventDefault();
        const d = summary.parentElement;
        if (hover.matches && d.open) return;
        d.open ? close(d) : open(d);
        return;
      }
      document.querySelectorAll('details[data-sl-mega][open]').forEach((d) => {
        if (!d.contains(e.target)) close(d);
      });
    });
    document.addEventListener('keyup', (e) => {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('details[data-sl-mega][open]').forEach((d) => {
        close(d);
        d.querySelector('summary').focus();
      });
    });
  })();

  /* Drawer móvil */
  class SlMenuDrawer extends HTMLElement {
    connectedCallback() {
      this.drawer = this.querySelector('[data-sl-drawer]');
      this.openBtn = this.querySelector('[data-sl-open]');
      this.openBtn.addEventListener('click', () => this.open());
      this.querySelectorAll('[data-sl-close]').forEach((b) => b.addEventListener('click', () => this.close()));
      this.querySelectorAll('.sl-dr__toggle').forEach((t) =>
        t.addEventListener('click', () => {
          const sub = document.getElementById(t.getAttribute('aria-controls'));
          const exp = t.getAttribute('aria-expanded') === 'true';
          t.setAttribute('aria-expanded', String(!exp));
          if (sub) sub.hidden = exp;
        })
      );
      this.onKey = (e) => {
        if (e.key === 'Escape') this.close();
      };
    }
    open() {
      this.drawer.classList.add('is-open');
      this.openBtn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('overflow-hidden');
      const sec = this.closest('.section-header');
      if (sec) sec.classList.add('menu-open');
      document.addEventListener('keydown', this.onKey);
      const panel = this.drawer.querySelector('.sl-dr__panel');
      if (panel) setTimeout(() => panel.focus(), 50);
    }
    close() {
      this.drawer.classList.remove('is-open');
      this.openBtn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('overflow-hidden');
      const sec = this.closest('.section-header');
      if (sec) sec.classList.remove('menu-open');
      document.removeEventListener('keydown', this.onKey);
      this.openBtn.focus();
    }
  }
  if (!customElements.get('sl-menu-drawer')) customElements.define('sl-menu-drawer', SlMenuDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selora-recensioni"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('selora-recensioni')) {
    class SeloraRecensioni extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.srv__viewport');
        this.slides = Array.from(this.querySelectorAll('.srv__slide'));
        this.dots = Array.from(this.querySelectorAll('.srv__dot'));
        this.n = this.slides.length;
        if (!this.n) return;
        this.index = Math.min(parseInt(this.dataset.start || '0', 10), this.n - 1);
        this.prevD = [];
        this.classList.add('is-ready');
        this.layout(true);
        this.dots.forEach((d) =>
          d.addEventListener('click', () => this.go(parseInt(d.dataset.go, 10)))
        );
        this.bindDrag();
        this.ro = new ResizeObserver(() => this.layout(true));
        this.ro.observe(this.viewport);
        this.slides.forEach((s) => this.ro.observe(s));
        const ms = parseInt(this.dataset.autoplay || '0', 10);
        if (ms > 0) {
          this.timer = setInterval(() => {
            if (!this.hovering) this.go(this.index + 1);
          }, ms * 1000);
          this.addEventListener('mouseenter', () => (this.hovering = true));
          this.addEventListener('mouseleave', () => (this.hovering = false));
        }
        this.addEventListener('shopify:block:select', (e) => {
          const i = this.slides.indexOf(e.target.closest('.srv__slide'));
          if (i > -1) this.go(i);
        });
      }
      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
        if (this.timer) clearInterval(this.timer);
      }
      isStacked() {
        return this.classList.contains('srv--m-stacked') && window.matchMedia('(max-width: 749px)').matches;
      }
      layout(instant) {
        if (this.isStacked()) {
          this.viewport.style.height = '';
          this.slides.forEach((s) => (s.style.transform = ''));
          return;
        }
        const vw = this.viewport.clientWidth;
        const sw = this.slides[0].offsetWidth;
        const c = (vw - sw) / 2;
        const n = this.n;
        this.slides.forEach((s, i) => {
          let d = (((i - this.index) % n) + n) % n;
          if (d > n / 2) d -= n;
          const prev = this.prevD[i];
          const jump = instant || prev === undefined || Math.abs(d - prev) > 1;
          s.classList.toggle('no-anim', jump);
          s.style.transform = 'translateX(' + (c + d * sw) + 'px)';
          s.classList.toggle('is-selected', i === this.index);
          s.setAttribute('aria-hidden', i === this.index ? 'false' : 'true');
          this.prevD[i] = d;
        });
        this.dots.forEach((d, i) => d.classList.toggle('is-selected', i === this.index));
        const cur = this.slides[this.index];
        this.viewport.style.height = cur.offsetHeight + 'px';
        if (instant) {
          requestAnimationFrame(() => this.slides.forEach((s) => s.classList.remove('no-anim')));
        }
      }
      go(i) {
        this.index = ((i % this.n) + this.n) % this.n;
        this.layout(false);
      }
      bindDrag() {
        let x0 = null;
        let y0 = null;
        this.viewport.addEventListener('pointerdown', (e) => {
          x0 = e.clientX;
          y0 = e.clientY;
        });
        const end = (e) => {
          if (x0 === null) return;
          const dx = e.clientX - x0;
          const dy = e.clientY - y0;
          x0 = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) this.go(this.index + (dx < 0 ? 1 : -1));
        };
        this.viewport.addEventListener('pointerup', end);
        this.viewport.addEventListener('pointercancel', () => (x0 = null));
      }
    }
    customElements.define('selora-recensioni', SeloraRecensioni);
  }

  } catch(e) { console.error(e); }
})();
})();
